/**
 * Changelog data for "What's New" feature
 * Sync with CHANGELOG.md when releasing new versions
 */

export const CURRENT_VERSION = '0.9.5-beta';

export interface ReleaseHighlight {
  emoji: string;
  textKey: string; // i18n key for translation
}

export interface ReleaseNote {
  date: string;
  highlights: ReleaseHighlight[];
}

export const RELEASE_NOTES: Record<string, ReleaseNote> = {
  '0.9.5-beta': {
    date: '2025-01-19',
    highlights: [
      { emoji: '📱', textKey: 'whatsNew.highlight.partialSheet' },
      { emoji: '👆', textKey: 'whatsNew.highlight.swipeableToasts' },
      { emoji: '🎨', textKey: 'whatsNew.highlight.dashboardCards' },
    ]
  },
  '0.9.4-beta': {
    date: '2025-12-26',
    highlights: [
      { emoji: '🎨', textKey: 'whatsNew.highlight.lucideIcons' },
      { emoji: '🔗', textKey: 'whatsNew.highlight.badgesNavigation' },
    ]
  },
  '0.9.2-beta': {
    date: '2025-12-22',
    highlights: [
      { emoji: '✨', textKey: 'whatsNew.highlight.profilePage' },
      { emoji: '✏️', textKey: 'whatsNew.highlight.editProfile' },
      { emoji: '🎨', textKey: 'whatsNew.highlight.animations' },
    ]
  },
  '0.9.1-beta': {
    date: '2025-12-09',
    highlights: [
      { emoji: '🎮', textKey: 'whatsNew.highlight.gamification' },
      { emoji: '📊', textKey: 'whatsNew.highlight.weeklyReflection' },
      { emoji: '🏆', textKey: 'whatsNew.highlight.badges' },
    ]
  },
  '0.9.0-beta': {
    date: '2025-12-01',
    highlights: [
      { emoji: '🎤', textKey: 'whatsNew.highlight.voiceInput' },
      { emoji: '🔄', textKey: 'whatsNew.highlight.recurring' },
      { emoji: '🌍', textKey: 'whatsNew.highlight.multiLanguage' },
    ]
  }
};

/**
 * Get release notes for a specific version
 */
export function getReleaseNotes(version: string): ReleaseNote | undefined {
  return RELEASE_NOTES[version];
}

/**
 * Get the current version's release notes
 */
export function getCurrentReleaseNotes(): ReleaseNote | undefined {
  return RELEASE_NOTES[CURRENT_VERSION];
}
